jQuery($ => {
  class NotificationPopup {
    constructor(element) {
      this._           = element;
      this._element    = $(element);
      this._modal      = this._element.find('.m-modal');
      this._id         = this._element.attr('id');
      this._condition  = this._element.data('condition');
      this._storageKey = 'notificationPopupState';

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      setTimeout(() => {
        if ( typeof this._modal.modal == 'undefined') {
          this._modal.on('loaded', this.handleMaybeOpen);
        } else {
          this.handleMaybeOpen();
        }
      }, 100);
    }

    getShownStateKey = () => {
      return this._storageKey + this._id;
    }

    getShownState = () => {
      const key = this.getShownStateKey();

      return localStorage.getItem(key) == 'shown';
    }

    setShownState = () => {
      const key = this.getShownStateKey();

      return localStorage.setItem(key, 'shown');
    }

    isConditionMet = () => {
      if ( !this._condition ) return true;

      switch ( this._condition.type ) {
        case 'utm':
          return window.location.search.includes(`${this._condition.key}=${this._condition.value}`);
        default:
          return false;
      }
    }

    handleMaybeOpen = () => {
      if ( !this.isConditionMet() ) return this._element.remove();
      
      if ( this.getShownState() ) return this._element.remove();

      this._modal.modal('handleOpen');
      this.setShownState();
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.notification_popup = function() {
    var _ = this,
        opt = arguments[0],
        args = Array.prototype.slice.call(arguments, 1),
        l = _.length,
        i,
        ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].notification_popup = new NotificationPopup(_[i], opt);
      else
        ret = _[i].notification_popup[opt].apply(_[i].notification_popup, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-notification-popup').notification_popup();
});